export default {
  'seo:default-description':
    'Premium Pet Food from Pets Deli | BARF Menus, Wet Food, Dry Food & Snacks for Dogs and Cats ✓ 100% Species-Appropriate ✓ Food Grade Quality ✓ → Discover now!',
};
